// A centrallized controller manager to handle map to map interactions

var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};

/**
 * Object to hold state of current maps in the UI
 */

OCS.Viewer.Functions.define_controller_manager = function () {
    OCS.Viewer.Classes.ControllerManager = new Class({
        Extends: OCS.Viewer.Classes.SingletonManager,
        class_name: "ControllerManager",
        manager_name: 'ControllerManager',
        bound_methods: {},
        dataworker_activation_timeout: null,
        options: {
            class_name: "OCS.Viewer.ControllerManager",
            max_num_linked_maps: 4,
            anchored_offset: 24 * 60 * 60 * 1000,
            debug: false
        },
        map_move: false,
        maps: {
            map_ctrlrs: [],
            linked_maps: [],
            linked_time: null,
            linked_view: null,
            linked_properties: {
                mouse_position: [],
                current_frame: null,
                
            }
        },
        init: function (op) {
            this.setOptions(op);

            // Initialize Web Worker
            if (OCS.Viewer.Functions.use_workers()) {
                this.dataworker_activation_timeout = setTimeout(this.start_data_worker.bind(this), OCS.Viewer.Config.dataworker_start_time);
                OCS.Viewer.Functions.get_event_manager().subscribe({event_name: OCS.Viewer.Config.events.DATAWORKER_ONLINE, callback: this.on_dataworker_online.bind(this), fire_immediately: true, once: true});
            }



            var datetime_ops = {time_duration_millsecs: 5 * 60 * 1000 * 1, animation_loop_length: 5 * 61 * 1000 * 1};
            var local = new Date().getTime();
            var offset = OCS.DateTime - local;
            if ((offset * -1) > this.options.anchored_offset || offset > this.options.anchored_offset) {
                datetime_ops.server_to_local_offset = 1;
                datetime_ops.anchor = true;
                OCS.Settings.anchor = OCS.DateTime;
            }
            var datetime = OCS.Functions.get_OCSDateTime(datetime_ops);
            if (datetime_ops.anchor) {
                datetime.set_anchor(OCS.DateTime);
            }
            this.load_user_data();



        },
        // Actions
        add_map_ctrlr: function (obj) {
            this.maps.map_ctrlrs.push(obj);
        },
        remove_map_ctrlr: function (obj) {
            this.maps.map_ctrlrs.erase(obj);
        },
        load_user_data: function () {
            if (OCS.User) {

            }
        },
        fire_global_event: function () {

        },
        link_map: function (map_ctrlr) {
            if (this.maps.linked_maps.length >= this.options.max_num_linked_maps) {
                return false;
            }
            var ocsmap = map_ctrlr.get_ocsmap();
            if (!this.is_map_linked(ocsmap)) {
                ocsmap.linked = true;
                var map_datetime = ocsmap.get_map_datetime_obj();
                this.maps.linked_maps.push(ocsmap);
                // Syncing up time settings
                if (!this.maps.linked_time) {
                    this.maps.linked_time = new OCS.Viewer.Classes.MapDateTime(map_datetime.options);
                    this.maps.linked_time.set_current_time_settings(map_datetime.get_current_time_settings());
                }
                map_datetime.set_linked_datetime(this.maps.linked_time);

                // Sync up mouse position
                if (!this.maps.linked_properties.mouse_position) {
                    this.set_linked_mouse_position(ocsmap.mouse_position);
                }
                this.addEvent('linked_mouse_position_change', ocsmap.bound_events.linkedpointermove);
                
                // Sync up shared view
                var map_view = ocsmap.get_map_view();
                if (!this.maps.linked_view) {
                    this.maps.linked_view = new OCS.Viewer.Classes.OlMapView();
                    this.maps.linked_view.set_center(map_view.get_center());
                    this.maps.linked_view.set_resolution(map_view.get_resolution());
                }
                map_view.mutually_bind_view(this.maps.linked_view);
                this.init_linked_map();
                this.map_linked();
                return true;
            }

            return false;

        },
        unlink_map: function (map_ctrlr) {
            var ocsmap = map_ctrlr.ocsmap;
            var map_datetime = ocsmap.get_map_datetime_obj();
            map_datetime.set_linked_datetime(null);
            this.uninit_linked_map();
            var map_view = ocsmap.get_map_view();
            map_view.unbind_view();
            this.removeEvent('linked_mouse_position_change', ocsmap.bound_events.linkedpointermove);

            var idx = this.maps.linked_maps.indexOf(ocsmap);
            this.maps.linked_maps.splice(idx, 1);

            if (!this.maps.linked_maps.length) {
                this.maps.linked_time.destroy();
                this.maps.linked_time = null;
            }
            this.map_unlinked();

        },

        init_linked_map: function () {
            if (this.maps.linked_maps.length > 1) {
                for (var i = 0; i < this.maps.linked_maps.length; i++) {
                    if (this.maps.linked_maps[i].add_tracker) {
                        this.maps.linked_maps[i].add_tracker();
                    }
                }
            }
        },
        uninit_linked_map: function () {
            if (this.maps.linked_maps.length <= 2) {
                var util = OCS.Viewer.Functions.get_utilities();
                for (var i = 0; i < this.maps.linked_maps.length; i++) {
                    if (!util.is_undefined(this.maps.linked_maps[i].tracker_layer)) {
                        this.maps.linked_maps[i].remove_tracker();
                    }
                }
            }
        },

        //
        // Event fires
        //
        map_linked: function () {
            this.fireEvent('map_linked', {linked: this.maps.linked_maps.length});
        },
        map_unlinked: function () {
            this.fireEvent('map_unlinked', {linked: this.maps.linked_maps.length});
        },
        ping_status: function (evt) {
            this.fireEvent('ping_status', evt);
        },
        //
        // Event Listeners
        //
        on_dataworker_message: function (event) {
            if (event.cmd) {
                switch (event.cmd) {
                    case 'ping_status':
                        this.ping_status(event.options);
                        break;
                    case 'shutdown':
                        this.destroy();
                        break;
                }
            }
        },
        on_dataworker_online: function () {
            OCS.Viewer.Functions.send_data_worker_message({
                'cmd': 'subscribe_init',
                'options': {
                    'channels': [OCS.Viewer.Config.xmpp_cmd_channel]
                }
            });
        },

        //
        // queries
        //
        is_map_linked: function (ocsmap) {
            var idx = this.maps.linked_maps.indexOf(ocsmap);
            if (idx > -1) {
                return true;
            } else {
                return false;
            }
        },
        //
        // Getter / Setter methods
        //
        get_map_ctrlr: function (panel_num) {
            if (this.maps.map_ctrlrs[panel_num]) {
                return this.maps.map_ctrlrs[panel_num];
            }
        },
        get_map_ctrlrs: function () {
            return this.maps.map_ctrlrs;
        },
        get_global_datetime: function () {
            return OCS.Functions.get_OCSDateTime();
        },
        set_linked_mouse_position: function(position) {
            var old = this.maps.linked_properties.mouse_position;
            var util = OCS.Viewer.Functions.get_utilities();
            if(position && util.is_array(position)) {
                if(!util.is_array_equal(this.maps.linked_properties.mouse_position, position)) {
                    this.maps.linked_properties.mouse_position = position;
                    this.fireEvent('linked_mouse_position_change', {"old": old, "coordinate": position, "property": "mouse_position"});
                }
            }

        },
        // Destroy
        destroy: function (callback) {
            Object.values(this.maps.map_ctrlrs).each(function (cntrl) {
                cntrl.destroy();
            });
            setTimeout(function () {
                OCS.Viewer.Functions.complete_destroy();
                if (callback) {
                    callback();
                }
            }, 0);
            if (this.dataworker_activation_timeout) {
                clearTimeout(this.dataworker_activation_timeout);
                this.dataworker_activation_timeout = null;
            }
            this.destroy_manager();

        }
    });
    OCS.Viewer.Classes.ControllerManager.implement(OCS.Viewer.Interfaces.DataWorker);
    OCS.Viewer.Functions.get_controller_manager = function (ops) {
        if (!OCS.Viewer.Live.ControllerManager) {
            new OCS.Viewer.Classes.ControllerManager(ops);
        }
        return OCS.Viewer.Live.ControllerManager;
    };
};

OCS.Viewer.Functions.define_moment = function () {
    /**
     * Changing moment.js locale
     * http://momentjs.com/docs/#/i18n/instance-locale/
     */
    moment.lang('en', {
        relativeTime: {
            future: "in %s",
            past: "-%s",
            s: "0m",
            m: "1m",
            mm: "%dm",
            h: "%dhr",
            hh: "%dhr",
            d: "d",
            dd: "%dd",
            M: "m",
            MM: "%dmon",
            y: "y",
            yy: "%dy"
        }
    });
};
OCS.Viewer.Functions.define_controller_manager();
OCS.Viewer.Functions.define_moment();
